import { Field } from "@reactables/react-forms";
import { Spinner } from "react-bootstrap";
import { useHistory } from "react-router-dom";
import { Card, Alert } from "react-bootstrap";
import { TwoStageButton } from "@jauntin/react-ui";
import SelectList from "Features/Shared/Components/SelectList";
import { RxCoverageApplicationProp } from "../../Rx/RxCoverageApplication/RxCoverageApplication";
import EventRadioBtn from "./EventRadioBtn";
import { getControl } from "Features/CoverageApplication/Rx/RxCoverageApplication/Selectors/form.selector";
import * as EventTypeSelectors from "../../Rx/RxCoverageApplication/Selectors/eventTypes.selector";
import CallCenter from "../../../../Assets/Images/icon-call-center.svg";
import RecentPurchasePopUp from "Features/RecentPurchasePopUp/Components/RecentPurchasePopup";

const EventSelect = ({
  rxCoverageApplication: [state, actions],
}: {
  rxCoverageApplication: RxCoverageApplicationProp;
}) => {
  const history = useHistory();
  const { eventType: selectedEvent } = state.applicationForm.root.value;

  const showError = state.touchButtons.eventType && !selectedEvent;
  return (
    <>
      <div className="eventSelect d-flex justify-content-center">
        <div className="eventSelect card--width-lg card--main">
          {state.referral.venueReferral.loading ? (
            <div className="d-flex align-items-center justify-content-center mh--hf container">
              <Spinner animation="border" role="status" />
            </div>
          ) : (
            <>
              <div className="text-center w-100 mt-4">
                <h1 className="mb-0">Select your event.</h1>
              </div>
              <Card.Body>
                <div className="event-help-card">
                  <img className="mr-4" src={CallCenter} alt="Help" />
                  <div>
                    If you do not see your event category, please call{" "}
                    <a href="tel:+1-844-747-6240" className="c-charcoal">
                      (844) 747-6240
                    </a>{" "}
                    to confirm event eligibility.
                  </div>
                </div>
                <h4 className="text-center">Most popular events:</h4>
                <div className="form-group form-row">
                  {EventTypeSelectors.getIconEventTypes(state).map((type) => (
                    <EventRadioBtn
                      icon={type.selectionIcon}
                      eventTypeRadio={type}
                      key={type.identifier}
                      text={type.name}
                      description={type.description}
                      action={actions.applicationForm.selectEventType}
                    />
                  ))}
                </div>
                <div className="label h4">Other events</div>
                <div className="row">
                  <div className="col-12 col-md-5 pr-md-0">
                    <Field
                      component={SelectList}
                      name="eventCategoryFilter"
                      options={EventTypeSelectors.getEventCategoryOptions(
                        state
                      )}
                      onChange={actions.applicationForm.selectEventCategory}
                      placeholder="Select the category"
                      showErrors={() => false}
                      searchable
                      isClearable
                    />
                  </div>
                  <div className="col-12 col-md-7 pl-md-2">
                    <Field
                      component={SelectList}
                      className="flex-grow-1"
                      name="eventType"
                      options={EventTypeSelectors.getListEventTypesOptions(
                        state
                      )}
                      onChange={actions.applicationForm.selectEventType}
                      placeholder="What is the event...?"
                      showErrors={() => false}
                      searchable
                    />
                  </div>
                </div>
                {showError && (
                  <Alert variant="danger">
                    <i className="fas fa-times-circle alert__icon" />
                    <div className="c-charcoal">
                      <strong>You must select an event to continue</strong>
                      <br />
                      For Assistance, please call{" "}
                      <a href="tel:+1-844-747-6240" className="c-charcoal">
                        (844) 747-6240
                      </a>
                    </div>
                  </Alert>
                )}

                {(() => {
                  const eventTypeValid = getControl(state, "eventType").valid;
                  const actionEnabled = eventTypeValid;

                  return (
                    <div className="d-flex justify-content-end">
                      <TwoStageButton
                        actionEnabled={actionEnabled}
                        disabled={showError}
                        action={() =>
                          history.push(`/${selectedEvent.identifier}`)
                        }
                        touch={() => actions.touchButton("eventType")}
                        className="btn btn-primary"
                        text="Continue"
                      />
                    </div>
                  );
                })()}
              </Card.Body>
            </>
          )}
        </div>
      </div>
      <RecentPurchasePopUp />
    </>
  );
};

export default EventSelect;
